import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PARTNER_KEYS = ['carrier', 'road', 'customs', 'warehouse', 'destination'];
const STAGE_KEYS = ['request', 'review', 'coordination', 'proposal', 'followUp'];

const CoordinationFlow = () => {
  const { t } = useTranslation();

  return (
    <section
      id="coordination-flow"
      className="py-20 md:py-28 bg-white scroll-mt-24"
      data-testid="coordination-flow-section"
    >
      <div className="container-custom">
        <div className="max-w-3xl mb-14">
          <span className="text-gold text-sm font-semibold tracking-wider uppercase mb-4 block">
            {t('homePage.coordinationFlow.eyebrow')}
          </span>
          <h2 className="font-space text-3xl md:text-4xl font-bold text-navy-900 mb-4">
            {t('homePage.coordinationFlow.title')}
          </h2>
          <p className="text-lg text-slate-600">{t('homePage.coordinationFlow.intro')}</p>
        </div>

        {/* Coordination diagram (text based, readable on every screen size) */}
        <div className="rounded-2xl border border-platinum-light bg-offwhite p-6 md:p-10 mb-14">
          <div className="grid lg:grid-cols-3 gap-6 items-stretch">
            <div className="rounded-xl bg-white border border-platinum-light p-6">
              <p className="font-space font-bold text-navy-900">
                {t('homePage.coordinationFlow.diagram.shipment')}
              </p>
            </div>

            <div className="rounded-xl bg-navy-900 p-6 text-center">
              <p className="font-space font-bold text-white">
                {t('homePage.coordinationFlow.diagram.elementaryCargo')}
              </p>
              <p className="text-platinum-light text-sm mt-2">
                {t('homePage.coordinationFlow.diagram.coordinationPoint')}
              </p>
            </div>

            <div className="rounded-xl bg-white border border-platinum-light p-6">
              <p className="font-space font-bold text-navy-900 mb-1">
                {t('homePage.coordinationFlow.diagram.partners')}
              </p>
              <p className="text-sm text-slate-500 mb-3">
                {t('homePage.coordinationFlow.mobilePartnersLabel')}
              </p>
              <ul className="space-y-2">
                {PARTNER_KEYS.map((key) => (
                  <li key={key} className="text-sm text-slate-700">
                    {t(`homePage.coordinationFlow.diagram.${key}`)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <ol className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {STAGE_KEYS.map((key, index) => (
            <li key={key} className="rounded-xl border border-platinum-light bg-white p-6 h-full">
              <span className="font-space text-gold font-bold text-lg" aria-hidden="true">
                {`0${index + 1}`}
              </span>
              <h3 className="font-space text-lg font-bold text-navy-900 mt-2 mb-2">
                {t(`homePage.coordinationFlow.stages.${key}.title`)}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                {t(`homePage.coordinationFlow.stages.${key}.description`)}
              </p>
            </li>
          ))}
        </ol>

        <div className="mt-12">
          <Link to="/contact">
            <Button variant="outline" className="border-2 border-navy-900 text-navy-900 hover:bg-navy-900 hover:text-white px-8 py-4">
              {t('homePage.coordinationFlow.cta')}
              <ArrowRight className="ml-2 w-5 h-5" aria-hidden="true" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CoordinationFlow;
